module.exports = __webpack_public_path__ + "img/183.f1b8bcc7.jpg";